export const UPDATE_FREE_GIFT_TO_CART_ENDPOINT = '/OsimCart/UpdateFreeGiftPopup';
